module.exports = require("uuid");


/*****************
 ** WEBPACK FOOTER
 ** external "uuid"
 ** module id = 6
 ** module chunks = 0
 **/